if (!customElements.get('pr-footer')) {
  customElements.define('pr-footer', class extends HTMLElement {
    connectedCallback() {
      this.controller?.abort();
      this.controller = new AbortController();
      const { signal } = this.controller;
      const desktop = matchMedia('(min-width: 1000px)');
      const menus = [...this.querySelectorAll('.pr-footer-menu')];
      const sync = () => menus.forEach(menu => {
        menu.open = desktop.matches;
        const summary = menu.querySelector('summary');
        if (desktop.matches) {
          summary.setAttribute('tabindex', '-1');
          summary.setAttribute('aria-disabled', 'true');
        } else {
          summary.removeAttribute('tabindex');
          summary.removeAttribute('aria-disabled');
        }
      });
      desktop.addEventListener('change', sync, { signal });
      this.addEventListener('click', event => {
        if (desktop.matches && event.target.closest('.pr-footer-menu > summary')) event.preventDefault();
      }, { signal });
      sync();
    }
    disconnectedCallback() { this.controller?.abort(); }
  });
}
